var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 3H8a5.006 5.006 0 0 0-5 5v11.757l4.469-4.468a5 5 0 0 1 7.063 0L18 18.757l1.469-1.468a5 5 0 0 1 7.063 0L29 19.757V8a5.006 5.006 0 0 0-5-5zm-3.5 10a3 3 0 1 1 3-3 3 3 0 0 1-3 3z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.117 18.7a3 3 0 0 0-4.234 0l-2.18 2.18a1 1 0 0 1-1.406 0l-4.18-4.18a3 3 0 0 0-4.234 0L3 22.586V24a5.006 5.006 0 0 0 5 5h16a5.006 5.006 0 0 0 5-5v-1.414z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic);
export default __webpack_public_path__ + "static/media/Pic.50950fe4e3dc14c0e26b885b0679065a.svg";
export { ForwardRef as ReactComponent };